module.exports = "https://static.energy5.com/_next/static/images/perfect6-f14188dd441d47084f94c39f5aee71a9.png";